<svelte:options accessors/>
<script lang="ts">
    import MainOverlay from "../layout/MainOverlay.svelte";
    import {onMount} from "svelte";
    import {getSelectedCity} from "../../utils";
    import {Cart, getCart} from "../../models/cart";
    import LinearProgress from "@smui/linear-progress";

    export let regiones: Array<any> = [];
    export let open = false;
    let selCity: any;
    let loading: boolean;
    let params: any;

    $: currentCity = regiones.find((x) => selCity && x.id === selCity.id);

    onMount(() => {
        const cityId = getSelectedCity();
        selCity = regiones.find(r => r.id === cityId)
        const url = new URLSearchParams(window.location.search);
        params = Object.fromEntries(url.entries());
    });

    async function selectCity() {
        if (selCity) {
            loading = true;
            localStorage.setItem('selectedCity', JSON.stringify(selCity))
            const {id} = selCity;
            const cart: Cart = await getCart();
            await cart.updateCity(id);
            loading = false;
            if (params.origen) {
                window.location.href = params.origen;
            } else {
                window.location.href = window.location.pathname;
            }
        }
        open = false;
    }

</script>
<div class="w-100 border-bottom" style="height: 35px">
    <div class="container h-100 box-b max-w-900px mx-auto">
        <div class="box-l sx-i h-100">
            {#if currentCity}
                <img height="16" src="/static/storefront/pix/icons/ubicacion-ciudad.svg">
                <p style="font-size:15px;">{currentCity.name}</p>
            {/if}
        </div>
        <div class="box-r sx-i pointer" on:click={()=> open = true}>
            <img height="16" src="/static/storefront/pix/icons/cambiar-vehiculo.svg">
            <div class="underlined" style="color: #4C4C4C;">Cambiar</div>
        </div>
    </div>
</div>
<MainOverlay checkout="{true}" bind:open={open}>
    <div class="container max-w-900px mx-auto">
        <div class="py-1">
            {#if loading}
                <div class="text-c loading-bar">
                    <LinearProgress class="w-100" indeterminate/>
                    <small>Actualizando ciudad...</small>
                </div>
            {:else}
                <div class="mb-2">
                    <h2 class="mb-1">Selecciona tu ciudad</h2>
                    <p>Selecciona de la lista la ciudad para actualizar tu ubicación</p>
                </div>
                <select bind:value={selCity} class="naui-input">
                    <option value={null}>Seleccione una ciudad</option>
                    {#each regiones as reg}
                        <option value={reg}>{reg.name}</option>
                    {/each}
                </select>
                <div class="box mt-3">
                    <div class="btn accent solid" on:click={selectCity}>Cambiar ciudad</div>
                </div>
            {/if}
        </div>
    </div>
</MainOverlay>